import React, { useState } from "react";
import axios from "axios";
import routes from "../../app/routes";
import Table from "./Table";
import PageTitle from "../ui/PageTitle";

export default function Index({
  teamId,
  enterpriseId,
  showCreateButton = true,
  referencePage,
  roles,
}) {
  return (
    <>
      {referencePage === "list" && <PageTitle title="Managers" />}

      <div className="ibox-content mt20">
        {referencePage !== "list" && (
          <h2 className="block-title">Management</h2>
        )}
        <Table
          showCreateButton={showCreateButton}
          teamId={teamId}
          enterpriseId={enterpriseId}
          roles={roles}
        />
      </div>
    </>
  );
}
